import { FC } from 'react';

import { BodyText, Headline, Page } from '@servicetitan/design-system';

export const AccessDeniedPage: FC = () => (
    <Page header={<Headline size="large">Access Denied</Headline>}>
        <BodyText>You do not have the required permissions to access this site.</BodyText>
    </Page>
);
